
import { defineComponent, ref, onBeforeMount } from 'vue'
import MBanner from './banner.vue'
import Meeting from './meeting.vue'
import FlowChart from './flow-chart/index.vue'
import TitleCom from '@/components/TitleCom/index.vue'
import { reqMeetingList } from '@/api/home'

export default defineComponent({
  components: {
    MBanner,
    TitleCom,
    FlowChart,
    Meeting
  },
  setup() {
    const meetingList = ref([])

    onBeforeMount(async () => {
      const temp = await reqMeetingList({ limit: 99999, page: 1 })
      meetingList.value = temp.gridlist
    })
    return {
      meetingList
    }
  }
})
